<template>
  <div>
    <v-chip label small class="primary my-1" v-if="produto.$melhorPrazoPagamento">
      {{ formaPagamentoDescription }} {{ prazoPagamento }}
    </v-chip>
    <span v-if="!produto.$melhorPrazoPagamento">
      {{ formaPagamentoDescription }} {{ prazoPagamento }}
    </span>
  </div>
</template>

<script>
import { FormaPagamento } from 'px-business-components';

export default {
  props: {
    produto: Object,
  },
  computed: {
    formaPagamentoDescription() {
      if (this.produto.formaPagamento === FormaPagamento.keys.A_VISTA.key) {
        return FormaPagamento.keys.A_VISTA.description;
      }
      return '';
    },
    prazoPagamento() {
      if (this.produto.prazoPagamento) {
        return this.produto.prazoPagamento.descricao;
      }
      return null;
    },
  },
};
</script>
